import { useEffect, useRef } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { VALUATION_METHODS } from '../constants';
import { ValuationSettings } from '../../models/ValuationSettings';

interface UseValuationMethodChangeProps {
  currentValue: string;
  setValue: UseFormSetValue<ValuationSettings>;
  setIsWarningDialogOpen: (open: boolean) => void;
  setPendingValue: (value: string | null) => void;
  initialValue: string | null;
}

const useValuationMethodChange = ({
  currentValue,
  setValue,
  setIsWarningDialogOpen,
  setPendingValue,
  initialValue,
}: UseValuationMethodChangeProps) => {
  const previousValueRef = useRef<string>(VALUATION_METHODS.CURRENT_CASE_COST);

  useEffect(() => {
    if (!initialValue || currentValue === previousValueRef.current) return;

    // Check if we're changing away from the initial loaded value
    if (previousValueRef.current === initialValue && currentValue !== initialValue) {
      // Moving away from initial value - show warning
      setPendingValue(currentValue);
      setIsWarningDialogOpen(true);
      // Reset to previous value - keep it dirty so buttons remain visible
      setValue('valuationMethod', previousValueRef.current, { shouldDirty: true });
    } else {
      // Allow the change
      previousValueRef.current = currentValue;
    }
  }, [currentValue, setValue, setIsWarningDialogOpen, setPendingValue, initialValue]);

  return previousValueRef;
};

export default useValuationMethodChange;
